module.exports = __webpack_public_path__ + "static/media/3.a53f09f6.gif";